import { useForm } from 'react-hook-form';
import { useAppSelector, useAppDispatch } from 'store/hooks/useStore';
import {
  registrationActions,
  registrationSelectors,
} from 'store/reducers/menuCategoryReducer/registrationSlice';
import * as menuCategoryApi from 'api/menuCategoryApi';
import { loaderActions } from 'store/reducers/loaderReducer/loaderSlice';
import { REGISTRATION_STEP } from 'constants/registrationStep';
import { useToast } from 'hooks/useToast';
import {
  MenuCategoryRegistrationFormFields,
  createMenuCategoryRegistrationFormFields,
  mapFormFieldsToMenuCategoryRegistrationPayload,
} from '../types/menuCategoryRegistrationFormFields';
import { useListStore } from './useListStore';

/**
 * メニューカテゴリー登録 store の実装をコンポーネントから隠すための中間層
 */
export const useRegistrationStore = () => {
  const dispatch = useAppDispatch();
  const { fetchMenuCategories } = useListStore();
  const toast = useToast();

  const form = useForm<MenuCategoryRegistrationFormFields>({
    defaultValues: createMenuCategoryRegistrationFormFields({}),
    mode: 'all',
  });
  const { getValues, reset, handleSubmit } = form;

  const isOpenModal = useAppSelector(registrationSelectors.isOpenModal);

  const currentModalStep = useAppSelector(
    registrationSelectors.currentModalStep,
  );

  const onCloseModal = () => {
    dispatch(registrationActions.initialize());
    reset();
  };

  const onCloseModalWhenCompleted = () => {
    onCloseModal();
    void fetchMenuCategories();
  };

  const onConfirm = () => {
    dispatch(registrationActions.updateStep(REGISTRATION_STEP.CONFIRMATION));
  };

  const onGoBack = () => {
    dispatch(registrationActions.updateStep(REGISTRATION_STEP.INPUT));
  };

  const onSubmit = handleSubmit(
    async (values: MenuCategoryRegistrationFormFields) => {
      dispatch(loaderActions.setLoading(true));
      const result = await menuCategoryApi.addMenuCategory(
        mapFormFieldsToMenuCategoryRegistrationPayload(values),
      );
      if (result.ok) {
        dispatch(registrationActions.updateStep(REGISTRATION_STEP.RESULT));
      } else {
        toast({
          status: 'error',
          description: 'カテゴリーの登録に失敗しました。',
        });
      }
      dispatch(loaderActions.setLoading(false));
    },
    () => {
      toast({
        status: 'error',
        description: 'カテゴリーの登録に失敗しました。',
      });
    },
  );

  return {
    /** メニューカテゴリー登録モーダル表示状態 */
    isOpenModal,
    /** メニューカテゴリー登録モーダルの現ステップ */
    currentModalStep,
    /** モーダル閉じる */
    onCloseModal,
    /** 登録完了後モーダル閉じる */
    onCloseModalWhenCompleted,
    /** 確認画面へ */
    onConfirm,
    /** 入力画面へ戻る */
    onGoBack,
    /** 入力を送信 */
    onSubmit,
    /** フォーム */
    form,
    /** フォーム values */
    values: getValues(),
  };
};
